// src/dataProvider.js
import { fetchUtils } from 'react-admin';
import simpleRestProvider from 'ra-data-simple-rest';

const origin = window.location.origin; // prod: https://panel.haymestasarim.com
const base = (process.env.REACT_APP_API_URL || origin).replace(/\/$/, '');
const apiUrl = `${base}/api`;

const mapResource = (resource) => {
  switch (resource) {
    case "geribildirim_yanitlari":
      return "geribildirim_yanitlari"; // sabitleme
    default:
      return resource;
  }
};


const httpClient = (url, options = {}) => {
  const opts = { ...options };
  if (!opts.headers) {
    opts.headers = new Headers();
  }
  // Her durumda Accept ayarla
  if (!opts.headers.has('Accept')) {
    opts.headers.set('Accept', 'application/json');
  }
  // Gönderimlerde JSON Content-Type
  if (opts.body && !opts.headers.has('Content-Type')) {
    opts.headers.set('Content-Type', 'application/json');
  }
  // Auth
  const token = localStorage.getItem('token');
  if (token && !opts.headers.has('Authorization')) {
    opts.headers.set('Authorization', `Bearer ${token}`);
  }

  return fetchUtils.fetchJson(url, opts);
};

const baseProvider = simpleRestProvider(apiUrl, httpClient);

// Header'dan total çek
const totalFromHeaders = (headers) => {
  if (!headers) return undefined;
  const cr = headers.get('Content-Range') || headers.get('content-range');
  if (!cr) return undefined;
  // ör: "geribildirimler 0-9/42" → 42
  const slashIdx = cr.lastIndexOf('/');
  if (slashIdx === -1) return undefined;
  const n = parseInt(cr.slice(slashIdx + 1), 10);
  return Number.isFinite(n) ? n : undefined;
};

const customProvider = {
  ...baseProvider,

  async getList(resource, params) {
    const { pagination, sort, filter } = params;

    const range = [
      (pagination.page - 1) * pagination.perPage,
      pagination.page * pagination.perPage - 1,
    ];

    const query = {
      sort: JSON.stringify([sort.field, sort.order]),
      range: JSON.stringify(range),
      filter: JSON.stringify(filter || {}),
    };

    const url = `${apiUrl}/${resource}?${fetchUtils.queryParameters(query)}`;

    try {
      const { json, headers, status } = await httpClient(url);

      // 401 ise login'e yönlendir (isteğe bağlı)
      if (status === 401) {
        // localStorage.removeItem('token');
        // window.location.href = '/login';
        throw new Error('Yetkisiz (401)');
      }

      // 1) API { data, total } döndürüyor olabilir
      if (json && typeof json === 'object' && !Array.isArray(json) && ('data' in json)) {
        return {
          data: json.data,
          total:
            json.total ??
            totalFromHeaders(headers) ??
            (Array.isArray(json.data) ? json.data.length : 0),
        };
      }

      // 2) API düz dizi döndürüyor + Content-Range header'ı var
      if (Array.isArray(json)) {
        return {
          data: json,
          total: totalFromHeaders(headers) ?? json.length,
        };
      }

      // 3) Tekil/diğer beklenmedik format durumda güvenli dönüş
      return {
        data: [],
        total: 0,
      };
    } catch (error) {
      console.error('🔴 getList hatası:', error);
      throw error;
    }
  },

async create(resource, params) {
  const data = { ...params.data };

  // tarih dd.MM.yyyy → yyyy-MM-dd dönüşümü
  if (data.tarih && typeof data.tarih === 'string' && data.tarih.includes('.')) {
    const [day, month, year] = data.tarih.split('.');
    data.tarih = `${year}-${month}-${day}`;
  }

  // 🔥 EN ÖNEMLİ DÜZELTME
  const res = mapResource(resource);
  const url = `${apiUrl}/${res}`;

  const { json } = await httpClient(url, {
    method: 'POST',
    body: JSON.stringify(data),
  });

  return { data: { ...json, id: json.id ?? json.ID ?? json.Id } };
}


};

export default customProvider;
